import {invalidatePartialInterest} from 'resources/mandark.resource';

/**
 * Refetches the class-scoped assignments list that `useClassGoogleClassroomSync` reads synced status
 * from. `useGoogleClassroomSync` only busts the single-assignment interest (the builder's own read
 * path), so without this a remount (e.g. after switching classes and back) would re-seed from the
 * pre-sync cache.
 */
export const invalidateClassGoogleClassroomSync = (classroomId: string) =>
  invalidatePartialInterest({resourcePath: ['classrooms_v1', classroomId, 'assignments_v3']});
